export default "__VITE_ASSET__BFFF3XJm__"